import React from 'react';
import { createRoot } from 'react-dom/client';
import InterestCalculator from './app/interest-calculator-app';

const element = document.getElementById('js-interest-calculation-app');

// Create a React root and render the component
const root = createRoot(element);
root.render(<InterestCalculator />);
